module.exports = __webpack_public_path__ + "img/katarina_amenities_3.5ec1f3b3.jpg";